<div class="help-block">
    <div class="help">
        <div class="help-header">
            <h4>Tutorials</h4>
        </div>
        <div class="help-list">
            <ul class="list-block">
                <li class="list"><a (click)="scrollTo('section1')">How to create an asset</a></li>
                <li class="list"><a (click)="scrollTo('section2')">How to create an asset from Locate Asset functionality</a></li>
                <li class="list"><a (click)="scrollTo('section3')">How to track assets using filters</a></li>
                <li class="list"><a (click)="scrollTo('section4')">How to create new user</a></li>
                <li class="list"><a (click)="scrollTo('section5')">How to track maintenance schedules</a></li>
                <li class="list"><a (click)="scrollTo('section6')">How to add Asset template</a></li>
            </ul>
        </div>
    </div>



<div class="video-section">


    <div id="section1" class="section">
        <p>How to create an asset</p>
        <div>
            <video width="640" height="400" controls>
                <source src="assets/videos/How to Create Asset from Asset List filter.webm" type="video/webm" />
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
    <div id="section2" class="section">
        <p>How to create an asset from Locate Asset functionality</p>
        <div>
            <video width="640" height="400" controls>
                <source src="assets/videos/How To Add Asset from Locate Asset Screen.webm" type="video/webm" />
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
    <div id="section3" class="section">
        <p>How to track assets using filters</p>
        <div>
            <video width="640" height="400" controls>
                <source src="assets/videos/How to track assets using various filters.webm" type="video/webm" />
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
    <div id="section4" class="section">
        <p>How to create new user</p>
        <div>
            <video width="640" height="400" controls>
                <source src="assets/videos/How to create new user.webm" type="video/webm" />
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
    <div id="section5" class="section">
        <p>How to track maintenance schedules</p>
        <div>
            <video width="640" height="400" controls>
                <source src="assets/videos/How to create maintenance schedules.webm" type="video/webm" />
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
    <div id="section6" class="section">
        <p>How to add Asset template</p>
        <div>
            <video width="640" height="400" controls>
                <source src="assets/videos/How to create Asset Template.webm" type="video/webm" />
                Your browser does not support the video tag.
            </video>
        </div>
    </div>

</div>

<div class="suggestion-block">
    <div class="suggestion">
        <p>Learning in progress. <a data-toggle="modal" data-target="#suggestionModal">Report</a> any issues to help us improve</p>
    </div>
</div>

</div>


 
 
 
 
<div class="modal fade" id="suggestionModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Suggestion
          <span data-dismiss="modal" (click)="closeModal()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="row">
            <div class="col-md-6 col-lg-6">
                <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control">
                </div>
            </div>
            <div class="col-md-6 col-lg-6">
                <div class="form-group">
                    <label>Email</label>
                    <input type="text" class="form-control">
                </div>
            </div>
            <div class="col-md-12 col-lg-12">
                <div class="form-group">
                    <label>Description</label>
                    <textarea type="text" class="form-control" name="" id=""></textarea>
                </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" (click)="closeModal()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="submitModal()" class="btn btn-primary">Send</button>
        </div>
      </div>
    </div>
  </div>
</div>